// extracted by mini-css-extract-plugin
export default {"fileList":"M4MjBJ","placeholder":"Otwn3P","minHeight":"wTl2x4","FileUploaderDefaultSkin":"OkRBQc","fileUploaderDefaultSkin":"OkRBQc"};